module.exports = __webpack_public_path__ + "static/dot-stick-doodles.0e1af0c0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/dot-stick-doodles.ttf
// module id = 452
// module chunks = 168707334958949